/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_G4Inputs */

const en_mk_mx_g4 = /** @type {(inputs: Mk_Mx_G4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI models & cost`)
};

const id_mk_mx_g4 = /** @type {(inputs: Mk_Mx_G4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model AI & biaya`)
};

/**
* | output |
* | --- |
* | "AI models & cost" |
*
* @param {Mk_Mx_G4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_g4 = /** @type {((inputs?: Mk_Mx_G4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_G4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_g4(inputs)
	return en_mk_mx_g4(inputs)
});